import React, {useState} from "react";
import {useIntl} from 'react-intl';

import {MAXIMUM_DESCRIPTION_LENGTH} from '../../../../constants'

type Props = {
  children: string,
};

export const ReadMore = (props: Props) => {
  const {formatMessage} = useIntl()
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <p className="overview-tab__text">
      {isReadMore ? props.children.slice(0, MAXIMUM_DESCRIPTION_LENGTH) : props.children}
      <span onClick={toggleReadMore} className="read-or-hide" hidden={props.children.length<MAXIMUM_DESCRIPTION_LENGTH}>
        {isReadMore ? formatMessage({id: 'app_gallery_read_more'}) 
          : formatMessage({id: 'app_gallery_show_less'})}
      </span>
    </p>
  );
};